<template>
  <div>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <b-row>
      <b-col cols="12" class="mb-4">
        <b-button
          variant="light"
          :to="{ name: 'product-delivery-restriction' }"
        >
          <i class="fas fa-arrow-left"></i> Back
        </b-button>
      </b-col>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col md="8">
              <div class="form-row form-group">
                <label class="col-md-3 col-form-label">รหัสสินค้า OFM </label>
                <div class="col-md-9 col-form-label">
                  <!-- <b-input-group class="mt-3">
                    <b-form-input
                      disabled
                      :value="skuCode"
                      type="text"
                      placeholder="รหัสสินค้า OFM"
                    ></b-form-input>
                    <b-input-group-append>
                      <a href="#" class="input-group-text">
                        <i class="fa fa-search"></i>
                      </a>
                    </b-input-group-append>
                  </b-input-group> -->

                  <span class="font-weight-bold">{{ skuCode }}</span>
                </div>
              </div>
            </b-col>
            <b-col md="4" class="text-right">
              <b-button @click="onDeleteSku" variant="danger">
                <i class="far fa-trash-alt"></i>
                Delete Product Restriction
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <div class="form-row form-group">
                <label class="col-md-3 col-form-label">รหัสกลุ่มสินค้า</label>
                <div class="col-md-9">
                  <span class="font-weight-bold">{{ productId }}</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <div class="form-row form-group">
                <label class="col-md-3 col-form-label">ชื่อสินค้า</label>
                <div class="col-md-9">
                  <span class="badge-lang">TH</span> {{ productName.th }}
                  <br />
                  <span class="badge-lang">EN</span> {{ productName.en }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <div class="form-row form-group">
                <label class="col-md-3 col-form-label">สถานะสินค้า</label>
                <div class="col-md-9">
                  <span
                    v-if="productSku.product_status"
                    class="label"
                    :class="
                      'label-' +
                        productSku.product_status.inventory.toLowerCase()
                    "
                    v-html="productSku.product_status.inventory"
                  ></span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <div class="form-row form-group">
                <label class="col-md-3 col-form-label">รหัสผู้ขาย</label>
                <div class="col-md-9">
                  <b-row v-if="productSku.vendor">
                    <b-col md="2">
                      <span class="badge-lang">Code</span>
                      {{ productSku.vendor.code }}
                    </b-col>
                    <b-col md="10">
                      <span class="badge-lang">TH </span>
                      {{ productSku.vendor.display_name.th }}
                      <br />
                      <span class="badge-lang">EN</span>
                      {{ productSku.vendor.display_name.en }}
                    </b-col>
                  </b-row>

                  <div></div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <div class="form-row form-group">
                <label class="col-md-3 col-form-label">สถานะการขาย</label>
                <div class="col-md-9">
                  <span
                    v-if="productSku.product_status"
                    class="label"
                    :class="
                      'label-' + productSku.product_status.sale.toLowerCase()
                    "
                    v-html="productSku.product_status.sale"
                  >
                  </span>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12">
        <b-card title="ข้อมูลที่อยู่ในระบบ">
          <b-row class="my-4">
            <b-col md="4">
              <div class="form-row form-group">
                <label class="col-md-3 col-form-label">รหัสไปรษณีย์ </label>
                <div class="col-md-9">
                  <b-form-input
                    v-model="filter.keyword"
                    type="text"
                    placeholder="รหัสไปรษณีย์"
                    @keydown.enter="onFilter"
                    @keypress="validateNum2($event)"
                    maxlength="5"
                  ></b-form-input>
                </div>
              </div>
            </b-col>
            <b-col md="4">
              <div class="form-row form-group">
                <b-button variant="primary" @click="onFilter">
                  <i class="fa fa-search"></i> Search
                </b-button>
                <b-button variant="light" @click="onReset">
                  <i class="fa fa-undo"></i> Reset
                </b-button>
              </div>
            </b-col>
            <b-col md="4" class="text-right">
              <b-button
                variant="success"
                @click="isShowAddPostcodeModal = true"
              >
                <i class="fa fa-plus"></i> Add Post Code
              </b-button>
            </b-col>
          </b-row>
          <BkTable
            :items="items"
            :fields="fields"
            :options="options"
            @ClickPagination="onClickPagination"
            @ChangePerPage="onChangePerPage"
            hideSearch
          >
            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a
                  @click="onDeletePostcode(data)"
                  class="btn btn-ico text-danger"
                  title="Delete"
                >
                  <i class="fas fa-trash-alt"></i>
                </a>
              </div>
            </template>
            <template v-slot:cell(create_info.timestamp)="{ value }">
              {{ FormatDate(value) }}
              {{ FormatTime(value) }}
            </template>
            <template v-slot:cell(province)="{ value }">
              <span class="badge-lang">TH</span> {{ value.th }}
              <br />
              <span class="badge-lang">EN</span> {{ value.en }}
            </template>
            <template v-slot:cell(create_info.user_name)="{ value }">
              <span class="badge-lang">TH</span> {{ value.th }}
              <br />
              <span class="badge-lang">EN</span> {{ value.en }}
            </template>
          </BkTable>
        </b-card>
      </b-col>
    </b-row>
    <AddPostcodeModal
      v-model="isShowAddPostcodeModal"
      :skuCode="skuCode"
      :productId="productId"
      @reload="onReload"
    ></AddPostcodeModal>
  </div>
</template>

<script>
import appConfig from '@/app.config'
import { FormatQty } from '@/helpers/utils/format-qty.js'
import PageHeader from '@/components/page-header'
import productDeliveryRestrictionService from '@/helpers/service/product-delivery-restriction-service.js'
import productService from '@/helpers/service/product-service.js'
import BkTable from '@/components/share/bk-table'
import AddPostcodeModal from '@/components/product-delivery-restriction/add-postcode-modal.vue'
import { FormatDate, FormatDateTime } from '@/helpers/utils/format-date.js'
import validate from '@/helpers/utils/validate.js'
export default {
  name: 'product-delivery-restriction-detail',
  page: {
    title: 'Product Delivery Restriction',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  mixins: [validate],
  components: {
    PageHeader,
    BkTable,
    AddPostcodeModal,
  },
  data() {
    return {
      title: 'Product Delivery Restriction Detail',
      itemsPageHeader: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Product Delivery Restriction',
          to: { name: 'product-delivery-restriction' },
        },
        {
          text: this.$route.params.id,
          active: true,
        },
      ],
      productSku: {},
      skuCode: '',
      productId: '',
      vendorCode: '',
      productName: { th: '', en: '' },
      items: [],
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'product_id',
          label: 'รหัสกลุ่มสินค้า',
          thStyle: 'width:120px',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          key: 'sku_code',
          label: 'รหัสสินค้า OFM',
          thStyle: 'width:120px',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'province',
          label: 'Province',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          key: 'postcode',
          label: 'Postcode',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          key: 'create_info.timestamp',
          label: 'วันและเวลาที่สร้าง',
          tdClass: 'text-center',

          sortable: true,
        },
        {
          key: 'create_info.user_name',
          label: 'ชื่อผู้สร้าง',
          tdClass: 'text-left',

          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      options: {
        pageNo: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRecords: null,
      },
      filter: {
        keyword: '',
      },
      isShowAddPostcodeModal: false,
    }
  },
  mounted() {
    const skuCode = this.$route.params.id
    this.getProductSkuByCodeAsync(skuCode)
  },
  methods: {
    async getPostcodeListBySkuCodesAsync() {
      const skuCode = this.skuCode
      const keyword = this.filter.keyword ? this.filter.keyword.trim() : ''
      const pageNo = this.options.pageNo
      const pageSize = this.options.perPage
      const sort = '-create_info.timestamp,postcode'

      let params = new URLSearchParams()
      params.append('keyword', keyword)
      params.append('pageNo', pageNo)
      params.append('pageSize', pageSize)
      params.append('sort', sort)

      const result = await productDeliveryRestrictionService.getPostcodeListBySkuCodesAsync(
        skuCode,
        params
      )
      if (result.status === 200) {
        this.items = result.data.items ? result.data.items : []
        this.options.totalRecords = result.data.totalRecords
        if (result.data.totalRecords === 0 && this.options.pageNo > 1) {
          this.options.pageNo = 1
          this.getPostcodeListAsync()
        }
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        this.$utils.notification(
          'error',
          'ไม่พบข้อมูล กรุณาตรวจสอบใหม่อีกครั้ง',
          2000
        )
        this.$router.push({ name: 'product-delivery-restriction' })
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async getProductSkuByCodeAsync(skuCode) {
      const result = await productService.getProductSkuByCodeAsync(skuCode)
      if (result.status === 200) {
        this.skuCode = result.data.id
        this.productName = result.data.product_names.find(
          it => (it.type || '').toUpperCase() === 'ONLINE'
        ).display_name
        this.productId = result.data.product_id
        this.productSku = result.data
        this.getPostcodeListBySkuCodesAsync()
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        this.$utils.notification(
          'error',
          'ไม่พบข้อมูล กรุณาตรวจสอบใหม่อีกครั้ง',
          2000
        )
        this.$router.push({ name: 'product-delivery-restriction' })
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onDeleteSku() {
      const confirm = await this.$utils.confirmAlertDisplay(
        'Delete Product Delivery Restriction',
        `ยืนยันการลบข้อมูลของรหัสสินค้า ${this.skuCode}!`
      )
      if (!confirm) {
        return
      }
      const result = await productDeliveryRestrictionService.deletePostCodesBySkuCode(
        this.skuCode
      )

      if (
        result.status === 201 ||
        result.status === 200 ||
        result.status === 204
      ) {
        this.$utils.notification('success', 'ลบข้อมูลสำเร็จ', 2000)
        this.$router.push({ name: 'product-delivery-restriction' })
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        this.$utils.notification('error', 'ลบข้อมูลไม่สำเร็จ', 2000)
        console.log('error', result.response.data.message)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onDeletePostcode({ item }) {
      const confirm = await this.$utils.confirmAlertDisplay(
        'Delete Product Delivery Restriction',
        `ยืนยันการลบข้อมูล<br/> รหัสไปรษณีย์ <span class="text-danger">${item.postcode}</span>  ของสินค้า <span class="text-danger">${this.skuCode}</span>!`
      )
      if (!confirm) {
        return
      }
      const data = [{ sku_code: this.skuCode, postcode: item.postcode }]
      const result = await productDeliveryRestrictionService.deletePostcodes(
        data
      )

      if (
        result.status === 201 ||
        result.status === 200 ||
        result.status === 204
      ) {
        this.$utils.notification('success', 'ลบข้อมูลสำเร็จ', 2000)
        this.getPostcodeListBySkuCodesAsync()
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        this.$utils.notification('error', 'ลบข้อมูลไม่สำเร็จ', 2000)
        console.log('error', result.response.data.message)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    onFilter() {
      this.options.pageNo = 1
      this.getPostcodeListBySkuCodesAsync()
    },
    onReset() {
      this.filter = {
        keyword: '',
      }
      this.getPostcodeListBySkuCodesAsync()
    },
    onClickPagination(val) {
      this.options.pageNo = val
      this.getPostcodeListBySkuCodesAsync()
    },
    onChangePerPage(val) {
      this.options.perPage = val
      this.getPostcodeListBySkuCodesAsync()
    },
    onReload() {
      this.getPostcodeListBySkuCodesAsync()
    },
  },
}
</script>

<style scoped></style>